module.exports = __webpack_public_path__ + "static/media/btn_resend.d93471c2.svg";